/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {message, Icon} from 'antd'
import {Link} from 'react-router-dom'
import Select from 'react-select'
import Loader from '../loaders/loader'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import moment from 'moment'
import jMoment from 'moment-jalaali'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {getParcelInfo} from '../../lib/path'
import {divIcon} from 'leaflet'
import {renderToStaticMarkup} from 'react-dom/server'
import {Map, Marker, TileLayer, Popup} from 'react-leaflet'

// const MyMap = withScriptjs(withGoogleMap(props =>

//     <GoogleMap
//         defaultZoom={10}
//         defaultCenter={{ lat: 35.74287570972717, lng: 51.54944953647805 }}
//     >
//         {props.markers.map((marker, index) => (
//             <Marker
//                 key={index}
//                 icon={require('../../image/requestPack.png')}
//                 position={{lat: marker.deliveryPackInfo.latitude, lng: marker.deliveryPackInfo.longitude}}
//             />
//         ))}

//     </GoogleMap>

// ))

export default class ImportOpTime extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showMap: false,
      date: null,
      drivers: [],
      driverId: null,
      cars: [],
      carId: null,
      file: '',
      fileName: '',
      markers: [],
      loading: false,
      deliveryPacksOutErrorList: [],
      deliveryPacksOutList: [],
      showError: false,
      currapted: false,
      failedToDispatchIds: []
    }
  }
  date(props) {
    return <input className="form-control" {...props} />
  }
  changeDate = (date) => {
    this.setState(
      {
        date
      },
      () => {
        if (this.state.date !== null) {
          this.loadAvailabelDrivers(this.state.date)
        }
      }
    )
  }
  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  epochFrom = (x) => {
    if (
      x.match(
        /^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/
      )
    ) {
      var concatDayMount = x.split('/')
      var concatDate = concatDayMount[1] + concatDayMount[2]
      var constantDate = '0631'
      var n = concatDate.localeCompare(constantDate)
      let miladiDate = jMoment(x, 'jYYYY/jMM/jDD').format('YYYY/MM/DD')
      let from = miladiDate + ' ' + '00:00'
      let fromEpoch = moment.utc(from).valueOf()
      if (n >= 0) {
        return fromEpoch - 3.5 * 3600 * 1000
      } else if (n < 0 && concatDate === '0101') {
        return fromEpoch - 3.5 * 3600 * 1000
      } else {
        return fromEpoch - 3.5 * 3600 * 1000
      }
    }
  }

  componentDidMount() {
    // Promise.all([
    //     this.getDrivers(),
    //     this.getCars()
    // ]).then(res => {
    // }).catch(err => {
    // })
  }

  loadAvailabelDrivers = (date) => {
    let jalaliDate = this.convertDigit(jMoment(date).format('jYYYY/jMM/jDD'))
    let planDate = this.epochFrom(jalaliDate)
    this.setState({
      loading: true
    })
    Promise.all([this.getFreeDrivers(planDate), this.getFreeCars(planDate)])
      .then((res) => {
        this.setState({
          loading: false
        })
        if (this.state.driverId !== null) {
          let findDriver = res[0].find((i) => i.personId === this.state.driverId.personId)
          if (!findDriver) {
            this.setState({
              driverId: null
            })
          }
        }
        if (this.state.carId !== null) {
          let findCar = res[1].find((i) => i.carId === this.state.carId.carId)
          if (!findCar) {
            this.setState({
              carId: null
            })
          }
        }
      })
      .catch((err) => {
        this.setState({
          loading: false
        })
      })
  }

  getFreeDrivers = (planDate) => {
    return http
      .get(`report/retail/list/free/drivers/date?planDate=${planDate}`, {})
      .then((res) => {
        if (res.data.error === null) {
          res.data.object.forEach((item) => {
            item.label = item.personId + ' - ' + item.name
            item.value = item.personId
          })
          this.setState({
            drivers: res.data.object
          })
          return res.data.object
        }
      })
      .catch(() => {})
  }

  getFreeCars = (planDate) => {
    return http.get(`report/retail/list/free/cars/date?planDate=${planDate}`, {}).then((res) => {
      if (res.data.error === null) {
        res.data.object.forEach((item) => {
          item.label = item.code + ' - ' + item.name + ' - ' + item.plate
          item.value = item.code
        })
        this.setState({
          cars: res.data.object
        })
        return res.data.object
      }
    })
  }

  changeDriver = (driverId) => {
    this.setState(
      {
        driverId
      },
      () => {
        if (this.state.driverId !== null) {
          let findCar = this.state.cars.find((item) => +item.carId === +this.state.driverId.carId)
          if (findCar) {
            this.setState({
              carId: findCar
            })
          } else {
            this.setState({
              carId: null
            })
          }
        } else {
          this.setState({
            carId: null
          })
        }
      }
    )
  }

  changeCar = (carId) => {
    this.setState({
      carId
    })
  }

  uploadFile = (e) => {
    let value = e.target.value
    if (value !== '') {
      if (value.includes('.csv')) {
        this.setState({
          fileName: value,
          file: e.target.files[0]
        })
      } else {
        message.error('فرمت فایل ارسالی باید csv باشد.')
      }
    } else {
      this.setState({
        fileName: '',
        file: ''
      })
    }
  }
  deleteFile = () => {
    document.getElementById('fileCsv').value = ''
    this.setState({
      fileName: '',
      file: ''
    })
  }

  searchDeliveryPack = () => {
    let {date, carId, driverId, file} = this.state
    if (date === null || carId === null || driverId === null || file === '') {
      message.error('فیلدهای ستاره دار وارد شود')
    } else {
      const formData = new FormData()
      formData.append('file', file)
      let jalaliDate = this.convertDigit(jMoment(this.state.date).format('jYYYY/jMM/jDD'))
      let planDate = this.epochFrom(jalaliDate)
      formData.append('planDate', planDate)
      formData.append('driverId', this.state.driverId.personId)
      formData.append('carId', this.state.carId.carId)
      this.setState({
        loading: true
      })
      http
        .post(`retail/company/plan/op-time/read`, formData, {})
        .then((res) => {
          this.setState({
            loading: false
          })
          if (res.data.error === null) {
            if (res.data.data === null) {
              this.setState(
                {
                  deliveryPacksOutErrorList: res.data.object.deliveryPacksOutErrorList,
                  deliveryPacksOutList: res.data.object.deliveryPacksOutList,
                  markers: this.state.deliveryPacksOutList,
                  currapted: false
                },
                () => {
                  if (this.state.deliveryPacksOutErrorList.length > 0) {
                    let {deliveryPacksOutErrorList} = this.state
                    deliveryPacksOutErrorList.forEach((item) => {
                      if (item.assigneeProblem && item.dateProblem) {
                        item.errorText =
                          ' مرسوله' +
                          '  ' +
                          item.deliveryPackInfo.deliveryPackId +
                          '  ' +
                          ' قبلا تخصیص داده شده است. همچنین با تاریخ انتخاب شده مغایرت دارد '
                      } else if (item.assigneeProblem && !item.dateProblem) {
                        item.errorText =
                          ' مرسوله' + '  ' + item.deliveryPackInfo.deliveryPackId + ' قبلا تخصیص داده شده است '
                      } else if (!item.assigneeProblem && item.dateProblem) {
                        item.errorText =
                          ' مرسوله' + '  ' + item.deliveryPackInfo.deliveryPackId + ' با تاریخ انتخاب شده مغایرت دارد '
                      } else if (item.notInDatabase) {
                        item.errorText = ' مرسوله' + '  ' + item.deliveryPackInfo.deliveryPackId + ' وجود ندارد '
                      }
                    })
                    this.setState({
                      deliveryPacksOutErrorList,
                      showMap: false,
                      showError: true
                    })
                  } else {
                    this.setState({
                      showMap: true,
                      showError: false,
                      markers: this.state.deliveryPacksOutList
                    })
                  }
                }
              )
            } else {
              let curraptedErrors = res.data.data
              curraptedErrors.forEach((item) => {
                item.errorText =
                  item.cellNumbers.length > 1
                    ? 'ستون‌های Priority و Order_id'
                    : 'ستون ' + this.convertColumnToText(item.cellNumbers)
              })
              this.setState({
                deliveryPacksOutErrorList: curraptedErrors,
                showMap: false,
                showError: true,
                deliveryPacksOutList: [],
                markers: [],
                currapted: true
              })
            }
          }
        })
        .catch(() => {
          this.setState({
            loading: false
          })
        })
    }
  }
  convertColumnToText = (cellNumber) => {
    if (cellNumber[0] === 1) {
      return 'Priority'
    } else if (cellNumber[0] === 2) {
      return 'Order_id'
    }
  }

  assign = () => {
    let {date, carId, driverId, file} = this.state
    if (date === null || carId === null || driverId === null || file === '') {
      message.error('فیلدهای ستاره دار وارد شود')
    } else {
      let deliveryPackOpTimes = []
      this.state.markers.forEach((item) => {
        deliveryPackOpTimes.push({
          rowNumber: item.rowNumber,
          deliveryPackId: item.deliveryPackInfo.deliveryPackId,
          priority: item.deliveryPackInfo.priority
        })
      })
      let jalaliDate = this.convertDigit(jMoment(this.state.date).format('jYYYY/jMM/jDD'))
      let planDate = this.epochFrom(jalaliDate)
      let model = {
        deliveryPackOpTimes,
        planDate,
        carId: this.state.carId.carId,
        driverId: this.state.driverId.personId
      }
      if (window.confirm('آیا از تخصیص نهایی مطمئن هستید؟؟')) {
        this.setState({
          loading: true
        })
        http
          .post(`retail/company/plan/op-time/assign`, model, {})
          .then((res) => {
            this.setState({
              loading: false
            })
            if (res.data.error === null) {
              if (res.data.object.failedToDispatchIds.length > 0) {
                this.setState({
                  failedToDispatchIds: res.data.object.failedToDispatchIds,
                  failDispatchModal: true
                })
              } else {
                message.success('تخصیص با موفقیت انجام شد. لطفا صبر کنید')
                setTimeout(() => {
                  window.location.reload()
                }, 2000)
              }
            }
          })
          .catch((err) => {
            this.setState({
              loading: false
            })
          })
      }
    }
  }
  updatePage = () => {
    this.setState(
      {
        failDispatchModal: false
      },
      () => {
        message.success('لطفا صبر کنید.')
        setTimeout(() => {
          window.location.reload()
        }, 2000)
      }
    )
  }

  getMarkers() {
    let points = this.state.markers
    console.log(points)
    const array = []
    points.forEach((item) => {
      if (item.deliveryPackInfo.latitude && item.deliveryPackInfo.longitude) {
        array.push({
          location: [item.deliveryPackInfo.latitude, item.deliveryPackInfo.longitude],
          ...item
        })
      }
    })
    return array
  }

  render() {
    let {date} = this.state
    const unSelected = renderToStaticMarkup(<img src={require('../../image/requestPack.png')} />)
    return (
      <div>
        <Loader show={this.state.loading} />
        <div className="container-fluid">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>توزیع</li>
            <li>تخصیص با فایل optime</li>
          </ul>
          <div className="bg-white my-3 p-3">
            <div className="row">
              <di className="col-12">
                <div className="card">
                  <div className="card-header">
                    <span className="font-weight-bold">تخصیص به رساننده از طریق فایل Op time</span>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12 col-md-4 col-lg-3 my-2 my-lg-0">
                        <label>
                          <span>تاریخ :</span>
                          <span className="text-danger mx-1">*</span>
                        </label>
                        <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                          <DatePicker
                            okLabel="تأیید"
                            autoOk={true}
                            leftArrowIcon={<Icon type="left" />}
                            rightArrowIcon={<Icon type="right" />}
                            cancelLabel="لغو"
                            labelFunc={(date) => (date == null ? '' : date.format('jYYYY/jMM/jDD'))}
                            value={this.state.date}
                            id="date"
                            ref={(node) => (this.planDate = node)}
                            onChange={this.changeDate}
                            TextFieldComponent={this.date}
                            readOnly
                          />
                        </MuiPickersUtilsProvider>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3 my-2 my-lg-0">
                        <div className="w-100">
                          <label>
                            <span>رساننده : </span>
                            <span className="text-danger mx-1">*</span>
                          </label>
                          <Select
                            value={this.state.driverId}
                            onChange={this.changeDriver}
                            options={this.state.drivers}
                            isClearable
                            placeholder="------"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3 my-2 my-lg-0">
                        <div className="w-100">
                          <label>
                            <span>اتومبیل : </span>
                            <span className="text-danger mx-1">*</span>
                          </label>
                          <Select
                            value={this.state.carId}
                            onChange={this.changeCar}
                            options={this.state.cars}
                            isClearable
                            placeholder="------"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-3 my-2 my-lg-0 position-relative">
                        {this.state.fileName !== '' && (
                          <img
                            onClick={this.deleteFile}
                            title="حذف فایل"
                            className="position-absolute cursor-pointer bg-white"
                            style={{
                              left: '90px',
                              top: '38px',
                              zIndex: '10',
                              cursor: 'pointer',
                              borderRadius: '50%'
                            }}
                            src={require('../../image/close.svg')}
                            width="20"
                            height="20"
                          />
                        )}
                        <label>
                          <span>فایل با فرمت csv</span>
                          <span className="text-danger mx-1">*</span>
                        </label>
                        <div className="input-group">
                          <div className="custom-file">
                            <input
                              type="file"
                              accept=".csv"
                              disabled={this.state.file === '' ? false : true}
                              className="custom-file-input"
                              id="fileCsv"
                              aria-describedby="inputGroupFileAddon01"
                              defaultValue={this.state.file}
                              onChange={this.uploadFile}
                            />
                            <label className="custom-file-label" htmlFor="inputGroupFile01">
                              {this.state.fileName === '' ? 'No file choosen' : this.state.fileName}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <button className="btn btn-md btn-primary mx-0" onClick={() => this.searchDeliveryPack()}>
                      پیش نمایش پارت‌های تحویل
                    </button>
                  </div>
                </div>
              </di>
            </div>
          </div>
          {this.state.showError && (
            <div className="bg-white my-3 p-3">
              <div className="alert alert-danger mb-0">
                {this.state.currapted ? (
                  <strong className="font-weight-bold">اشکالات فایل optime</strong>
                ) : (
                  <strong className="font-weight-bold">لیست خطاهای یافت شده در فایل optime</strong>
                )}
                <hr />
                {!this.state.currapted ? (
                  <ul className="px-3 mb-0">
                    {this.state.deliveryPacksOutErrorList.map((err, index) => (
                      <li className="my-1">
                        <span className="font-weight-bold">ردیف {err.rowNumber} - </span>
                        <span>{err.errorText}</span>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <ul className="px-3 mb-0">
                    {this.state.deliveryPacksOutErrorList.map((err, index) => (
                      <li className="my-1">
                        {/* <span className="font-weight-bold">ردیف {err.rowNumber} - </span> */}
                        <span>{err.errorText}</span>
                        <span className="">{' در ردیف ' + err.rowNumber + ' اشکال دارد '}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          )}
          {this.state.showMap && (
            <div className="bg-white addressMap my-3 p-3">
              <Map center={[35.6892, 51.389]} zoom={10} style={{height: '500px'}}>
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                {this.getMarkers().map((item, index) => (
                  <Marker
                    icon={divIcon({
                      html: unSelected,
                      iconSize: [30, 30],
                      iconAnchor: [10, 38]
                    })}
                    position={item.location}
                  />
                ))}
              </Map>

              {/* <MyMap
                                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDh3yzsorXDyP-gAlxEGUlzmfJ6nVxizUw&v=3.exp&libraries=geometry,drawing,places"
                                loadingElement={<div style={{ height: `100%` }} />}
                                containerElement={<div style={{ height: `400px` }} />}
                                mapElement={<div style={{ height: `100%` }} />}
                                markers={this.state.markers}
                            /> */}
              <div className="mt-3 text-center">
                <button className="btn btn-success" onClick={this.assign}>
                  تخصیص نهایی
                </button>
              </div>
            </div>
          )}
        </div>
        <Modal isOpen={this.state.failDispatchModal} toggle={() => this.updatePage()}>
          <ModalBody className="d-flex flex-column justify-content-center align-content-center align-items-center">
            <h5 className="text-center font-weight-bold">لیست مرسوله هایی که در به‌روزرسان وضعیتشان تغییر نکرده است</h5>
            <table className="baseTable">
              <tr className="firstRow" style={{fontSize: '2em'}}>
                <th>ردیف</th>
                <th>شماره مرسوله</th>
              </tr>
              {this.state.failedToDispatchIds.map((item, index) => (
                <tr style={{fontSize: '2em'}}>
                  <th>{index + 1}</th>
                  <th>
                    <a href={getParcelInfo({parcelId: item})} target="_blank">
                      {item}
                    </a>
                  </th>
                </tr>
              ))}
            </table>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}
